import React from 'react'
import { BadgeCardProps } from './types.d'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import ImageResolutions from '@toasttab/shared/src/components/atoms/Image/ImageResolutions'

const BadgeCard = ({ heading, description, images }: BadgeCardProps) => (
  <div data-testid='badgecard'>
    <div className='grid-cols-4 ds-grid gap-y-0'>
      <div className='col-span-4 lg:col-span-1 center mb-8 lg:mb-0'>
        <ImageResolutions
          imageAlt={
            images.imageResolutions[0].desktop[0].title
              ? images.imageResolutions[0].desktop[0].title
              : null
          }
          borderRadius={
            images.imageResolutions[0].borderRadius
              ? images.imageResolutions[0].borderRadius.label
              : 'None'
          }
          images={images}
          classes='w-100 none overflow-hidden'
        />
      </div>
      <div className='col-span-4 lg:col-span-3'>
        <Typography
          as='h5'
          variation='h5'
          classes='text-color-primary text-center lg:text-left'
        >
          {heading}
        </Typography>
        <Typography
          as='p'
          variation='default'
          classes='text-color-secondary text-center lg:text-left'
        >
          {description}
        </Typography>
      </div>
    </div>
  </div>
)

export default BadgeCard
